// extracted by mini-css-extract-plugin
export default {"row":"row_row__wzKvF"};